import { breakpointQueries } from '../constants/breakpoint-queries'
import { BreakpointsStateInterface } from '../types/breakpoints-state'

export const getCurrentBreakpoints = (): BreakpointsStateInterface => ({
  isXS: window.matchMedia(breakpointQueries.isXS).matches,
  isSM: window.matchMedia(breakpointQueries.isSM).matches,
  isMD: window.matchMedia(breakpointQueries.isMD).matches,
  isLG: window.matchMedia(breakpointQueries.isLG).matches,
  isXL: window.matchMedia(breakpointQueries.isXL).matches,
  is2XL: window.matchMedia(breakpointQueries.is2XL).matches,
})
